module.exports = "<div class=\"wrapper\" ng-if=\"$ctrl.error\"><h3 class=\"h3\" ng-bind=\"$ctrl.error.code\"></h3><h3 class=\"text-danger h3\" ng-bind=\"$ctrl.error.error\"></h3><h4 class=\"h4\" ng-bind=\"$ctrl.error.error_description\"></h4></div><div class=\"main-loader\" ng-if=\"!$ctrl.error\"><img src=\"/assets/images/init-loader.gif\"/><h4 class=\"text-center\">Initializing Your Account</h4></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/oauth/oauth.pug
// module id = 261
// module chunks = 0